import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { ROLE_SEARCH_START_LOADING, ROLE_SEARCH_END_LOADING, ROLE_SEARCH_LOADED, SET_ROLE_FILTER } from "../constants/RoleConstants";
import { ROLE_START_LOADING, ROLE_END_LOADING, ROLE_LOADED } from "../constants/RoleConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        active: ""
    },
    loadingFBO: false,
    fbo: null
};

const RoleReducer = (state = initialState, action) => {
    switch(action.type) {
        case ROLE_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case ROLE_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case ROLE_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_ROLE_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case ROLE_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case ROLE_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case ROLE_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default RoleReducer;